import { render } from "./zoho-payment-history.vue?vue&type=template&id=7963882e"
import script from "./zoho-payment-history.vue?vue&type=script&lang=js"
export * from "./zoho-payment-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__